<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'vehicles.vehicles' | translate }}</span>
  <button mat-icon-button matDialogClose>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<div fxLayout="row" fxLayoutAlign="center">
  @if (isVehicleLoading$ | async) {
    <mat-spinner></mat-spinner>
  }
</div>

@if (!(isVehicleLoading$ | async) && vehicle$ | async) {
  <div>
    <form [formGroup]="vehicleForm" appReadOnlyWithoutPermission="ROLE_USER" (ngSubmit)="persistVehicle()">
      <mat-dialog-content>
        <mat-form-field>
          <mat-label>{{ 'vehicles.licensePlate' | translate }}</mat-label>
          <input matInput type="text" formControlName="licensePlate">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'vehicles.licenseClass' | translate }}</mat-label>
          <mat-select placeholder="{{ 'vehicles.licenseClass'  | translate }}" formControlName="licenseClass">
            @for (licenceClass of licenseClasses$ | async; track licenceClass) {
              <mat-option [value]="licenceClass.id">
                {{ licenceClass.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'vehicles.description' | translate }}</mat-label>
          <input matInput type="text" formControlName="description">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'departments.department' | translate }}</mat-label>
          <mat-select placeholder="{{ 'departments.department' | translate }}" formControlName="department">
            @for (department of departments$ | async; track department['@id']) {
              <mat-option [value]="department['@id']">
                <span class="department-color" [style.background-color]="department.color"></span>
                {{ department.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button *ngxPermissionsOnly="['ROLE_USER']" color="accent" type="submit" [disabled]="vehicleForm.invalid">
          <mat-icon>check</mat-icon>
          {{ 'vehicles.actions.persist' | translate }}
        </button>
      </mat-dialog-actions>
    </form>
  </div>
}
